import React from 'react';
import { useFormik } from 'formik';
import CustomInput from "../ui/customInput/CustomInput";
import s from './ContactUsForm.module.css';
import { useAppDispatch } from "../../hooks/redux";
import { sendFormDataThunk } from "../../store/reducers/ActionCreators";
import * as yup from 'yup';
import MyBtn from '../ui/MyBtn/MyBtn';
import { useTranslation } from 'react-i18next';

const ContactUsForm = () => {
    const dispatch = useAppDispatch();

    const { t } = useTranslation();

    const validationSchema = yup.object({
        email: yup
            .string()
            .required(t('contactUsForm.validation.requiredField'))
            .email(t('contactUsForm.validation.invalidFormat')),
    });

    const formik = useFormik({
        initialValues: {
            firstName: '',
            lastName: '',
            email: '',
            message: '',
        },
        validationSchema,
        onSubmit: values => {
            const data = {
                subject: "Contact Form",
                data: values,
            };
            dispatch(sendFormDataThunk(data));
        },
    });

    return (
        <div className={s.form_wrapper}>
            <div className={s.form_content}>
                <form onSubmit={formik.handleSubmit}>
                    <CustomInput
                        id="firstName"
                        name="firstName"
                        type="text"
                        label={t('contactUsForm.firstNameLabel')}
                        placeholder={t('contactUsForm.placeholders.firstName')}
                        onChange={formik.handleChange}
                        value={formik.values.firstName}
                        pattern="[a-z, A-Z]*"
                    />
                    <CustomInput
                        id="lastName"
                        name="lastName"
                        type="text"
                        label={t('contactUsForm.lastNameLabel')}
                        placeholder={t('contactUsForm.placeholders.lastName')}
                        onChange={formik.handleChange}
                        value={formik.values.lastName}
                        pattern="[a-z, A-Z]*"
                    />
                    <CustomInput
                        id="email"
                        name="email"
                        type="email"
                        label={t('contactUsForm.emailLabel')}
                        placeholder={t('contactUsForm.placeholders.email')}
                        onChange={formik.handleChange}
                        value={formik.values.email}
                        isError={formik.errors.email ? s.input_error : ""}
                    />
                    <span className={s.label}>{t('contactUsForm.messageLabel')}</span>
                    <textarea
                        id="message"
                        name="message"
                        placeholder={t('contactUsForm.placeholders.message')}
                        onChange={formik.handleChange}
                        value={formik.values.message}
                        className={s.textarea}
                    />
                    <div className={s.btn_block}>
                        <MyBtn type='submit' title={t('contactUsForm.sendButton')} />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ContactUsForm;
